import React from "react";
import { HiOutlineArrowLeft } from "@react-icons/all-files/hi/HiOutlineArrowLeft";
import JobTitle from "./JobTitle";
import Logo from "./Logo";

const JobHead = ({
  logo,
  url,
  name,
  baseUrl,
  applyUrl,
  colorHeaderBg,
  colorHeaderText,
  colorButtonBg,
  colorButtonText,
  job,
  permalink,
  tabs,
  canApply
}) => {
  return (
    <div
      className="pt-4 pb-0 lg:pb-8"
      style={{ backgroundColor: colorHeaderBg }}
    >
      <div className="container">
        <div className="flex items-top">
          <div className="grow">
            <Logo
              url={url}
              logo={logo}
              name={name}
              colorHeaderText={colorHeaderText}
            />
          </div>
          <div className="shrink">
            <a
              href={baseUrl}
              className="text-xs font-medium hover:underline xl:text-base items-center flex justify-center space-x-2"
              style={{ color: colorHeaderText }}
            >
              <HiOutlineArrowLeft className="x-5 w-5" />
              Jobs
            </a>
          </div>
        </div>
        <JobTitle
          orgName={name}
          applyUrl={applyUrl}
          colorHeaderText={colorHeaderText}
          colorButtonBg={colorButtonBg}
          colorButtonText={colorButtonText}
          job={job}
          permalink={permalink}
          tabs={tabs}
          canApply={canApply}
        />
      </div>
    </div>
  );
};

export default JobHead;
